import { render, staticRenderFns } from "./SignUpThanks.vue?vue&type=template&id=6ea09366&scoped=true"
import script from "./SignUpThanks.vue?vue&type=script&lang=js"
export * from "./SignUpThanks.vue?vue&type=script&lang=js"
import style0 from "./SignUpThanks.vue?vue&type=style&index=0&id=6ea09366&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ea09366",
  null
  
)

export default component.exports